module.exports = __webpack_public_path__ + "img/stars.98deca6b.png";